import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-crema py-12" data-id="element-58" data-mp="3gf958x4mo89h">
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-8" data-id="element-59" data-mp="3gg11ma61ua0t">
        <p className="font-serif text-2xl text-borgona sm:text-3xl" data-id="element-60" data-mp="32oe2m2kq2nec">
          Deco <em className="font-script not-italic text-terracota" data-id="element-61" data-mp="32m1et8sa9itd">Emprende</em>
        </p>
        <div className="puntada mx-auto mt-4 h-[3px] w-24 text-rosa-200" aria-hidden="true" data-id="element-62" data-mp="36nd6rkymqg4q" />
        <p className="mx-auto mt-4 max-w-md font-sans text-sm leading-relaxed text-suave sm:text-base" data-id="element-63" data-mp="3ucxo5zf4x5bw">
          Puntadas de Papel es un producto 100% digital. No se realizan envíos
          físicos.
        </p>

        <nav aria-label="Enlaces legales" className="mt-6" data-id="element-64" data-mp="3lgosmvua2qv1">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 font-sans text-sm font-semibold text-frambuesa sm:text-base" data-id="element-65" data-mp="3qbvnde5kkl7t">
            <li data-id="element-66" data-mp="2ey9x1pnz4dkp">
              <a href="#" className="underline-offset-4 hover:underline" data-id="element-67" data-mp="2eyt8qon165qa">
                Términos y condiciones
              </a>
            </li>
            <li data-id="element-68" data-mp="3l9shv2i5sonf">
              <a href="#" className="underline-offset-4 hover:underline" data-id="element-69" data-mp="3lbdces4h47la">
                Política de privacidad
              </a>
            </li>
            <li data-id="element-70" data-mp="3v8rh5uh1b7xr">
              <a href="#" className="inline-flex items-center gap-2 underline-offset-4 hover:underline" data-id="element-71" data-mp="3v9b0nfmc24dw">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-72" data-mp="3q727oj9gn2bs" />
                Contacto
              </a>
            </li>
          </ul>
        </nav>

        <p className="mt-8 font-sans text-xs text-suave sm:text-sm" data-id="element-73" data-mp="34gvldp1el60">
          © {new Date().getFullYear()} Deco Emprende · Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}